import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import PageList from '#/modules/commonComponents/PageList';
import { can } from '#/modules/infra/auth/can';
import systemSettingNavigate from '#/modules/infra/navigation/systemSettingNavigate';

function isSettingLinkVisible(permissions, item) {
  if (Array.isArray(item.permissionAll) && item.permissionAll.length > 0) {
    return item.permissionAll.every((code) => can(permissions, code));
  }

  return !item.permission || can(permissions, item.permission);
}

const SystemSettingHubPage = () => {
  const permissions = useSelector((state) => state.infra.permissions);
  const linkList = useMemo(
    () => systemSettingNavigate.filter((item) => isSettingLinkVisible(permissions, item)),
    [permissions],
  );

  return <PageList title="系統設定" linkList={linkList} />;
};

export default SystemSettingHubPage;
